import TermsPage from "@/pages/landing/Terms";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(landing)/terms")({
  component: TermsPage,
});
